import { constants } from "../constants";

export default class LightNWonder {

    constructor(settings, gb) {
        this.settings = settings;
        this.gb = gb;
        this.wrapperCallBacks = {
            gameRevealed: this.gameRevealed,
            gcmReady: (gcm) => this.gcmReady(gcm),
            optionHasChanged: (optionType, newValue) => {
                switch (optionType) {
                    case 'MUTE':
                        this.isMute = newValue;
                        if (newValue) {
                            this.gb.emitters.emit.game.soundOff();
                        } else {
                            this.gb.emitters.emit.game.soundOn();
                        }
                        break;
                    case 'ABOUT':
                        this.gb.emitters.emit.game.openPaytable();
                        break;
                    case 'GAME_PREFERENCES':
                        break;
                    case 'PAYTABLE':
                        this.isPaytableOpened = newValue;
                        if (newValue) {
                            this.gb.emitters.emit.game.openPaytable();
                        } else {
                            this.gb.emitters.emit.game.closePaytable();
                        }
                        break;
                    case 'HELP':
                        this.isHelpOpened = newValue;
                        if (newValue) {
                            this.gb.emitters.emit.game.openHelp();
                        } else {
                            this.gb.emitters.emit.game.closeHelp();
                        }
                        break;
                    default:
                        throw Error('unknown option [' + optionType + '] changed by gcm ');
                }
            },
            balancesHasChanged: (balances) => {
                //Stops multiplcation that can occur due to JS compiler parsing floating points inaccurately,
                //for example; float 0.29 x 100 = 28.999999999999996

                var balance, freebetBalance = 0;

                if (balances.hasOwnProperty("CASH")) {
                    balance = balances['CASH']['amount'];
                }

                if (balances.hasOwnProperty("BONUS")) {
                    freebetBalance = balances['BONUS']['amount'];
                } else if (balances.hasOwnProperty("FREEBET")) {
                    freebetBalance = balances['FREEBET']['amount']
                }

                if (typeof balances['FREESPIN'] == 'object') {
                    freespinBalance = balances['FREESPIN']['amount'];
                    freespinCount = balances['FREESPIN']['count'];
                }

                const newbalance = parseInt(((balance + freebetBalance) * 100).toFixed(0), 10)
                if (this.isDebug) {
                    logger.debug("GDM from gcm - balancesHasChanged- bal : " + balance + "  freebet " + freebetBalance)
                }


                this.gb.emitters.emit.game.updateBalance({ balance: newbalance });
            },
            configReady: (config) => this.configReady(config),
            resume: this.resume,
            getGameName: this.getGameName,
            reload: this.reload,
            redirect: this.redirect,
            getPreferredCommonUIPosition: this.getPreferredCommonUIPosition,
            getConfig: this.getConfig,
            getOgsClientToken: this.getOgsClientToken,
            stopAutoplay: () => {
                logger.debug("GDM from gcm - stopAutoplay");
                this.gb.emitters.emit.game.suspendGame();
            },
            isJsonEmpty: this.isJsonEmpty
        };
        this.currentURL = window.location.href;
        this.resumable = false;
        this.isErrorInProgress = false;
        this.isMute = false;
        this.isHelpOpened = false;
        this.isPaytableOpened = false;
        this.currencyFormat = "";
        this.ogsParams = {};
        this.ogsClientToken = "";
        this.isGameReady = false;
        this.isDebug = true;
        this.cfgReady = false;
        this.realBalance = 0;
        this.bonusBalance = 0;
    }

    gameRevealed() {
        if (this.isDebug) {
            logger.debug("GameBridge: gameRevealed");
        }
    }

    gcmReady(gcm) {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance gcmReady");
        }


        this.gcmObj = gcm;

        if (this.gb.settings.aggLaunchErrorData) {
            var errorObj = JSON.parse(this.gb.settings.aggLaunchErrorData);

            this.gameLoaded();
            this.handleCustomError(errorObj.errorCategory, errorObj.errorSeverity, errorObj.errorCode, errorObj.errorMessage);
            return;
        }


        this.gcmObj.regOption('PAYTABLE');
        this.gcmObj.regOption('HELP');
        //gcm.regOption('ABOUT');
        this.isMute = this.gcmObj.regOption('MUTE');
    }

    getGameName() {
        //Need to call the game API to get game name.
        try {
            return "";
        } catch (err) {
            return "";
        }
    }

    //GAME2WEB
    balanceChange(realBalance, bonusBalance) {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance balanceChange", realBalance, bonusBalance, this.cfgReady);
        }
        //if config is not ready gcm will throw error Uncaught TypeError: Cannot read properties of null (reading 'format')
        if (!this.cfgReady) {
            this.realBalance = realBalance;
            this.bonusBalance = bonusBalance;
            return;
        }
        if (this.gcmInstance) {
            this.gcmInstance.balancesUpdate(
                {
                    'CASH': { amount: realBalance },
                    'BONUS': { amount: bonusBalance }
                }, 0);
        }
    }

    soundOff() {
        this.isMute = true;
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance optionHasChanged", 'MUTE', 'GAME', this.isMute);
        }

        if (this.gcmInstance) {
            this.gcmInstance.optionHasChanged('MUTE', 'GAME', this.isMute);
        }
    }

    soundOn() {
        this.isMute = false;
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance optionHasChanged", 'MUTE', 'GAME', this.isMute);
        }

        if (this.gcmInstance) {
            this.gcmInstance.optionHasChanged('MUTE', 'GAME', this.isMute);
        }
    }

    // this.callHandleMessageTrigger('<MESSAGE id="100" nogslang="en_uk"><TYPE>TEST</TYPE><TITLE>TEST</TITLE><TEXT>TEST</TEXT><OPTIONS count="1"><OPTION id="0">OK</OPTION></MESSAGE>');
    // this.callHandleMessageTrigger('<MESSAGE id="101" nogslang="en_uk"><TYPE>REALITYCHECK_UK</TYPE><TITLE>Responsible Gaming Reality Check</TITLE><TEXT>You have been playing for one hour. If you wish you can continue to play. Or exit the game. </TEXT><OPTIONS count="2"><OPTION id="0">YES</OPTION><OPTION id="100">NO</OPTION></OPTIONS></MESSAGE>');
    callHandleMessageTrigger(xmlMessage) {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance handleMessageTrigger", xmlMessage);
        }
        if (this.gcmInstance) { 
            this.gcmInstance.handleMessageTrigger(xmlMessage);
        }
    }

    isJsonEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    configReady(parameters) {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance configReady");
        }

        if (this.isJsonEmpty(this.ogsParams)) {
            this.ogsParams = parameters;
        }

        this.cfgReady = true;

        this.balanceChange(this.realBalance, this.bonusBalance);
        if (this.gcmInstance) {
            this.gcmInstance.loadProgressUpdate(0);
        }
        var wholeCurrencyExample = this.gcmInstance.paidUpdate(1.00);
        var fractionCurrencyExample = this.gcmInstance.paidUpdate(0.01);
        if (this.gcmInstance) {
            this.gcmInstance.paidUpdate(0.00);
        }
        this.currencyFormat = "CUR=ISO:";
        this.currencyFormat += wholeCurrencyExample.code + "|";
        this.currencyFormat += wholeCurrencyExample.ccy_thousand_separator + "|";
        this.currencyFormat += wholeCurrencyExample.ccy_decimal_separator + "|";
        var sym = "";
        if (wholeCurrencyExample.currency_symbol != undefined) {
            for (var a = 0; a < wholeCurrencyExample.currency_symbol.length; a++) {
                sym += wholeCurrencyExample.currency_symbol.charCodeAt(a) + ";";
            }
        }
        else {
            for (var a = 0; a < wholeCurrencyExample.code.length; a++) {
                sym += wholeCurrencyExample.code.charCodeAt(a) + ";";
            }
        }

        this.currencyFormat += sym + "|";
        this.currencyFormat += (!isNaN(wholeCurrencyExample.display.charAt(0)) ? "R" : "L") + "|";
        if (wholeCurrencyExample.currency_symbol == fractionCurrencyExample.currency_symbol) {
            this.currencyFormat += "32;|";
        } else {
            sym = "";
            for (var a = 0; a < fractionCurrencyExample.currency_symbol.length; a++) {
                sym += fractionCurrencyExample.currency_symbol.charCodeAt(a) + ";";
            }
            this.currencyFormat += sym + "|";

        }
        this.currencyFormat += (!isNaN(fractionCurrencyExample.display.charAt(0)) ? "R" : "L");
        // loadgame in gcmwrapper.html
        // loadSettingsFromConfigService(loadgame);
        //gcmObj.gameReady();
        //   gcmObj.paidUpdate(0.00);
    }

    //Is called with 2 params: {this.gcmCore_.game.resume("gameAnimationComplete",null)}
    resume(errorParamIndex, param1) {
        // logger.debug("GDM from gcm - resume - index " + errorParamIndex);
    }

    updateProgress(data) {
        let percentLoaded = +data;

        if( data < 1){
            percentLoaded = percentLoaded * 100
        }
        percentLoaded = Math.round(percentLoaded)

        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance loadProgressUpdate", percentLoaded);
        }
        if (this.gcmInstance) {
            this.gcmInstance.loadProgressUpdate(percentLoaded);
        }

        // if (gameiframe.width  != gameiframeSize.width &&
        //     gameiframe.height != gameiframeSize.height) {
        //     setGameIframeSizeFromParentWindow();
        // }
    }

    gameLoaded() {
        if (this.gcmInstance) { 
            this.gcmInstance.paidUpdate(0);
        }
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance gameReady");
        }
        if (this.gcmInstance) { 
            this.gcmInstance.gameReady();
        }
        this.isGameReady = true;

    }

    closeGame() {
        //this will redirect to lobby
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance handleCriticalError");
        }
        if (this.gcmInstance) {
            this.gcmInstance.handleError('CRITICAL', 'ERROR', '', '');
        }
    }

    //GAME2WEB
    closeHelp() {
        this.isHelpOpened = false;
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance optionHasChanged", 'PAYTABLE', 'GAME', this.isHelpOpened);
        }

        if (this.gcmInstance) {
            this.gcmInstance.optionHasChanged('PAYTABLE', 'GAME', this.isHelpOpened);
        }
    }

    //GAME2WEB
    closePaytable() {
        this.isPaytableOpened = false;
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance optionHasChanged", 'PAYTABLE', 'GAME', this.isPaytableOpened);
        }

        if (this.gcmInstance) {
            this.gcmInstance.optionHasChanged('PAYTABLE', 'GAME', this.isPaytableOpened);
        }
    }

    gameSpinStarted() {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance gameAnimationStart");
        }
        if (this.gcmInstance) {
            this.gcmInstance.gameAnimationStart();
        }
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance paidUpdate", 0);
        }
        if (this.gcmInstance) {
            this.gcmInstance.paidUpdate(0);
        }
    }

    gameSpinEnd() {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance gameAnimationComplete");
        }
        if (this.gcmInstance) {
            this.gcmInstance.gameAnimationComplete(this.wrapperCallBacks.resume);
        }
    }

    wonAmountChange(amount) {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance paidUpdate", amount);
        }
        if (this.gcmInstance) {
            this.gcmInstance.paidUpdate(amount);
        }
    }


    betAmountChange(data) {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance stakeUpdate", data);
        }
        if (this.gcmInstance) {
            this.gcmInstance.stakeUpdate(data);
        }
    }

    //for generic error messages sent from game client
    handleError(msg) {
        this.handleCustomError("CRITICAL", "ERROR", "", msg);
    }

    handleCustomError(errorCategory, errorSeverity, errorCode, errorMessage) {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance handleError", errorCategory, errorSeverity, errorCode, errorMessage);
        }
        if (this.gcmInstance) {
            this.gcmInstance.handleError(errorCategory, errorSeverity, errorCode, errorMessage);
        }
    }

    // outOfMoney() {
    //     this.handleCustomError("INSUFFICIENT_FUNDS", "ERROR", "", 'Balance is low. Please top-up');
    // }

    openHelp() {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance optionHasChanged", 'PAYTABLE', 'GAME', true);
        }
        if (this.gcmInstance) {
            this.gcmInstance.optionHasChanged('PAYTABLE', 'GAME', true);
        }
    }

    openPaytable() {
        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance optionHasChanged", 'PAYTABLE', 'GAME', true);
        }

        if (this.gcmInstance) {
            this.gcmInstance.optionHasChanged('PAYTABLE', 'GAME', true);
        }
    }


    /**
     * This method is a called by CommonUI when it wants to reload the page as part of error handling.
     * If desktop GCM then sends a post-message to gcm-launcher(which is the main page) to reload itself.
     * If mobile, GCM will attempt to invoke same on the game.
     * @public
     */
    reload() {
        window.reload();
    }

    /**
     * This method is a called by CommonUI when it wants to redirect the main window to a different page as a result of
     * error handling action(like login_error).
     * If desktop GCM then sends a post-message to gcm-launcher(which is the main page) to redirect to the requested page.
     * If mobile, GCM will attempt to invoke same function on the game.
     * @public
     * @param {String} redirectUrl The url to redirect current page
     */
    redirect(redirectUrl) {
        window.location = redirectUrl;
    }

    getPreferredCommonUIPosition() {
        return "centre";
    }

    getConfig(cfg) {
        this.ogsParams = cfg;
        if (typeof (this.ogsParams) == "undefined" || typeof (this.ogsParams.gameid) == "undefined") {
            return {
                'gameName': "",
                'gameLoadingScreen': false,
                'cuiPosition': this.getPreferredCommonUIPosition()
            };
        }

        if (this.isDebug) {
            logger.debug("<<<< GameBridge: gcmInstance getConfig", this.ogsParams.gameid, true, this.getPreferredCommonUIPosition());
        }

        return {
            'gameName': this.ogsParams.gameid,
            'gameLoadingScreen': true,
            'cuiPosition': this.getPreferredCommonUIPosition()
        };
    }

    getOgsClientToken() {
        return this.ogsClientToken;
    }

    addIframeLNWOGS() {
        document.getElementsByTagName("html")[0].style.height = "100%";
        document.getElementsByTagName("html")[0].style.width = "100%";
        document.getElementsByTagName("body")[0].style.height = "100%";
        document.getElementsByTagName("body")[0].style.width = "100%";
        document.getElementsByTagName("html")[0].style.padding = "0";
        document.getElementsByTagName("body")[0].style.padding = "0";
        document.getElementsByTagName("html")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.margin = "0";

        let container = document.querySelector("#gameContainer");

        if (!container) {
            container = document.createElement("div");
            container.id = "gameContainer";
            container.style.width = '100%';
            container.style.height = '100%';
            document.body.append(container);
        }

        let scriptTag = document.createElement('script');

        let configJsUrl = '';

        if (this.gb.queryParams.envid && this.gb.queryParams.stage) {
            const combinedKey = `${this.gb.queryParams.envid}&stage=${this.gb.queryParams.stage}`;

            switch (combinedKey) {
                case "eur&stage=1":
                    configJsUrl = "https://ogs-gcm-eu-stage.nyxop.net/gcm/config.js";
                    break;
                case "can&stage=1":
                    configJsUrl = "https://ogs-cdn-stage-ca.nyxop.net/gcm/config.js";
                    break;
                case "mi&stage=1":
                    configJsUrl = "https://ogs-cdn-stage-mi.nyxop.net/gcm/config.js";
                    break;
                case "usnj&stage=1":
                    configJsUrl = "https://ogs-cdn-usnj-stage.nyxop.net/gcm/config.js";
                    break;
                case "pa&stage=1":
                    configJsUrl = "https://ogs-gcm-pa-stage.nyxop.net/gcm/config.js";
                    break;
                case "pail&stage=1":
                    configJsUrl = "https://ogs-gcm-pail-stage.nyxop.net/gcm/config.js";
                    break;
                case "wv&stage=1":
                    configJsUrl = "https://ogs-cdn-stage-wv.nyxop.net/gcm/config.js";
                    break;
                case "latam&stage=1":
                    configJsUrl = "https://ogs-gcm-sa-stage.br.sgaws.net/gcm/config.js";
                    break;
            }
        }

        else if (this.gb.queryParams.envid && this.gb.queryParams.dev) {
            const combinedKey = `${this.gb.queryParams.envid}&dev=${this.gb.queryParams.dev}`;
            switch (combinedKey) {
                case "eur&dev=1":
                    configJsUrl = "https://ogs-gcm-eu-dev.nyxop.net/gcm/config.js";
                    break;
            }
        }

        else {
            switch (this.gb.queryParams.envid) {
                case "eur":
                    configJsUrl = "https://ogs-gcm-eu-prod.nyxop.net/gcm/config.js";
                    break;
                case "can":
                    configJsUrl = "https://ogs-cdn-ca.nyxop.net/gcm/config.js";
                    break;
                case "mi":
                    configJsUrl = "https://ogs-cdn-mi.nyxop.net/gcm/config.js";
                    break;
                case "usnj":
                    configJsUrl = "https://ogs-cdn-usnj.nyxop.net/gcm/config.js";
                    break;
                case "pa":
                    configJsUrl = "https://ogs-gcm-pa-prod.nyxop.net/gcm/config.js";
                    break;
                case "pail":
                    configJsUrl = "https://ogs-gcm-pail-prod.nyxop.net/gcm/config.js";
                    break;
                case "wv":
                    configJsUrl = "https://ogs-cdn-wv.nyxop.net/gcm/config.js";
                    break;
                case "latam":
                    configJsUrl = "https://ogs-gcm-sa-prod.br.sgaws.net/gcm/config.js";
                    break;
                case "local":
                    configJsUrl = "/gcm/config.js";
                    break;

                default:
                    configJsUrl = "https://ogs-gcm-eu-prod.nyxop.net/gcm/config.js";
                    break;
            }
        }

        logger.debug("<<<< GameBridge: config.js location", configJsUrl);

        scriptTag.setAttribute('src', configJsUrl);
        document.head.appendChild(scriptTag);

        var callbacks = this.wrapperCallBacks;
        scriptTag.onerror = () => {
            logger.debug("<<<< GameBridge: error loading config.js", this.src);
        }

        scriptTag.onload = () => {
            // GCMConfig.getGCMUr() needs a param or it will default to prod

            if (this.gb.queryParams.stage === "1") {
                this.settings.gcmUrl = GCMConfig.getGCMUrl("stage");

            } else if (this.gb.queryParams.dev === "1") {
                this.settings.gcmUrl = GCMConfig.getGCMUrl("dev");

            } else {
                this.settings.gcmUrl = GCMConfig.getGCMUrl();
            }


            logger.debug("<<<< GameBridge: gcm location", this.settings.gcmUrl);
            let gcmScriptTag = document.createElement('script');
            gcmScriptTag.setAttribute('src', this.settings.gcmUrl);
            document.head.appendChild(gcmScriptTag);
            gcmScriptTag.onload = () => {
                try {
                    this.gcmInstance = new gcm.GcmCore();
                    var isGcm4_0 = this.gcmInstance.init.length == 2;
                    logger.debug("<<<< GameBridge: gcmInstance init");
                    if (isGcm4_0) {
                        this.gcmInstance.init(callbacks,
                            this.settings.gcmUrl);
                    } else {
                        this.gcmInstance.init(callbacks,
                            this.settings.gcmUrl,
                            window.location.href);
                    }
                } catch (error) {
                    logger.debug("<<<< GameBridge: error loading gscm: ", error);
                }

                if (this.gb.settings.aggLaunchErrorData) {
                    return;
                }

                this.gameIframe = document.createElement("iframe");
                this.gameIframe.src = (this.gb.gameProviderProtocol === constants.EVP || this.settings.gameProviderCode === 'ENDOR') ? `${this.settings.launchLink}` : `${this.settings.launchLink}${this.settings.launchLink.indexOf("?") > -1 ? "&" : "?"}isGameBridge=true`;
                this.gameIframe.id = this.gb.gameProviderProtocol === constants.NSOFT ? 'seven-plugin' : 'gameWindow';
                this.gameIframe.style = "width: 100%; height: 100% !important; border: none;";
                this.gb.gameIframe = this.gameIframe;
                document.querySelector("#gameContainer").append(this.gameIframe);

                if (this.gb.settings.walletLaunchCMAMessage) {
                    this.callHandleMessageTrigger(atob(this.gb.settings.walletLaunchCMAMessage));
                }

                if (this.gb.settings.walletExtraInfoOnAuthenticate) {
                    var balanceObj = JSON.parse(this.gb.settings.walletExtraInfoOnAuthenticate);
                    this.balanceChange(balanceObj.realBalance, balanceObj.bonusBalance);
                }
            }

            gcmScriptTag.onerror = () => {
                logger.debug("<<<< GameBridge: error loading gcm", this.src);
            }
        }
        return this.gameIframe;
    }

}
